import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { FaPaperclip } from 'react-icons/fa';
import QuotationPreview from './QuotationPreview';
import { getCurrencySymbol, numberFormatter } from 'utils/currency';
import { useQuery, useQueryClient } from 'react-query';

import StatusBadge from 'ui-component/StatusBadge';
import PdfViewer from 'ui-component/PdfViewer';


import { Skeleton } from '@mui/material';
import { CommonDateOnlyFormat } from 'helpers/common.helper';

import usePermissions from 'hooks/usePermissions';

import QoutationComponent from 'views/estimation/components/QoutationComponent';
import SalesOrderComponent from 'views/estimation/components/SalesOrderComponent';
import InvoiceComponent from 'views/estimation/components/InvoiceComponent';

import ClientTimeline from 'ui-component/ClientTimeline';
import useIsMobile from 'utils/isMobileUtils';

import usePageTitle from 'hooks/usePageTitle';

const QuotationDetails = () => {
    const { id } = useParams();

    const [allPermissions, hasEveryPermission] = usePermissions();

    // Customer Create
    const [selectedEstimate, setSelectedEstimate] = useState();
    const [salesType, setSalesType] = useState('');
    const [showActions, setShowActions] = useState(false);

    const currentDate = moment().format('YYYY-MM-DD');



    // End Create
    const history = useNavigate();
    const [modalPrice, setModalprice] = useState('00');

    const [shippingRow, setShippingrow] = useState({
        quantity: 1,
        unitPrice: 0,
        totalPrice: 0
    });


    const [selectedCustomerinfo, setSelectedCustomerInfo] = useState({});
    const [subTotal, setSubtotal] = useState('00');
    const queryClient = useQueryClient();
    const location = useLocation();
    const pathParts = location.pathname.split('/');
    const [refreshKey, setRefreshKey] = useState(0);

    
    const queryParams = new URLSearchParams(location.search);


    const { data: requestData } = useQuery(
        ['client-quotations-details', id, location, showActions, refreshKey],
        () => {
            const queryParams = new URLSearchParams(location.search);
            setShowActions(true);
            return api.getClientQuotationDetails(id);
        },
        {
        }
    );

    const invalidateEstQuery = () => {

        queryClient.prefetchQuery({ queryKey: ['client-quotations-details', id, location, showActions] });
    };

    
    const [estimateRow, setEstimaterow] = useState({
        customer_id: '',
        estimate_number: '',
        sales_manager: '',
        transit_id: '',
        vatStatus: 'Including VAT',
        vatPrice: 21,
        startDate: currentDate,
        expiresIn: 7,
        currency: 'eur',
        notes: []
    });
    // Row Area
    const [rows, setRows] = useState([{ id: 1, modelId: '', type: '', quantity: 0, unitPrice: 0, total: 0 }]);

    //   End Row

    useEffect(() => {
        setEstimaterow((oldData) => ({ ...oldData, sales_manager: selectedCustomerinfo?.sales_manager_id }));
    }, [selectedCustomerinfo]);

    useEffect(() => {
        initiateDatas();

        const subPath = pathParts;
        subPath.pop();


        setRefreshKey(oldKey => oldKey + 1);
    }, [location]);



    useEffect(() => {
        if (requestData?.data?.data) {
            setSelectedEstimate(requestData?.data?.data);
          
            setSalesType('estimate');
            
        }
    }, [requestData]);

    const [defaultPageTitle, setDefaultPageTitle] = useState('');

    const [setPageTitle] = usePageTitle(defaultPageTitle); // Start with empty
    useEffect(() => {
        setDefaultPageTitle(salesType === 'invoice' ? 'Invoice' : salesType === 'estimate' ? 'Quotation' : '');
    }, [salesType]);
    
    const initiateDatas = () => {
        if (id) {
        } else {
            history('/client/quotations');
        }
    };
    
    const handleOpenNewTab = (pageModule, id) => {
        let url = '';
        if (pageModule == 'products') {
            url = `/products/${id}`;
        } else if (pageModule == 'contacts') {
            url = `/contacts/${id}`;
        } else if (pageModule == 'purchase_orders') {
            url = `/purchasing/view/${id}`;
        } else if (pageModule == 'sales_orders') {
            url = `/sales/sales-orders/${id}`;
        } else if (pageModule == 'invoices') {
            url = `/sales/invoices/${id}`;
        } else if (pageModule == 'quotations') {
            url = `/sales/quotations/${id}`;
        }
        if (url) {
            history(url);
        }
    };
    
    useEffect(() => {
        if (selectedEstimate) {
            const expDate = moment(selectedEstimate?.expires_at).format('YYYY-MM-DD');
            let tempRow = selectedEstimate?.estimation_details.map((item, index) => {
                return {
                    id: index,
                    modelId: item?.product_id,
                    type: item?.product?.product_name,
                    quantity: item?.qty,
                    unitPrice: Number(item?.unit_price),
                    total: item?.total_price
                };
            });

            tempRow = [
                ...tempRow,
                {
                    id: tempRow.length + 1,
                    modelId: '',
                    type: '',
                    quantity: '',
                    unitPrice: '',
                    total: ''
                }
            ];

            setRows(tempRow);
            setSelectedCustomerInfo(selectedEstimate.customer);
            setSubtotal(selectedEstimate?.subtotal);

            const temEstimate = {
                estimate_number: selectedEstimate?.estimation_number,
                customer_id: selectedEstimate?.customer_id,
                startDate: selectedEstimate?.start_date,
                expiryDate: expDate,
                transit_id: selectedEstimate?.transit_company?.id,
                sales_manager: selectedEstimate?.sales_person?.id,
                private_note: selectedEstimate?.private_note,
                vatStatus: selectedEstimate?.vat_type,
                vatPrice: selectedEstimate?.vat_percent || 21,
                currency: selectedEstimate?.currency,
                private_note: selectedEstimate?.private_note,
                expiresIn: moment(selectedEstimate?.expires_at).diff(selectedEstimate?.start_date, 'days')
            };

            let notesArray = [];

            selectedEstimate?.notes?.forEach((note) => {
                notesArray = [
                    {
                        id: note?.id,
                        details: note?.details,
                        date: moment(note?.created_at).format('YYYY-MM-DD'),
                        time: moment(note?.created_at).format('HH:mm'),
                        user_name: `${note?.user_created?.first_name} ${note?.user_created?.last_name}`,
                        expand: false,
                        isDeletable: note?.is_deletable
                    },
                    ...notesArray
                ];
            });

            notesArray = _.sortBy(notesArray, (n) => -n.id);

            setEstimaterow({ ...temEstimate, notes: notesArray });
        }
    }, [selectedEstimate]);

    const calculateTotal = () => {
        let total = 0;
        let grandTotal = 0;
        for (let i = 0; i < rows.length; i++) {
            const { quantity, unitPrice } = rows[i];
            total += parseFloat(quantity || 0) * parseFloat(unitPrice || 0);
        }

        if (shippingRow?.totalPrice > 0) {
            const shippingTotal = parseFloat(shippingRow.totalPrice);
            grandTotal = total + shippingTotal;
        } else {
            grandTotal = total;
        }

        if (isNaN(grandTotal)) {
            return { subtotal: '00', modelTotal: '00' };
        }
        return { subtotal: grandTotal, modelTotal: total };
    };

    useEffect(() => {
        let tempsubtotal = calculateTotal();
        const subTotals = parseFloat(tempsubtotal?.subtotal).toFixed(2);
        const modaltotal = parseFloat(tempsubtotal?.modelTotal).toFixed(2);
        setSubtotal(subTotals);
        setModalprice(modaltotal);
    }, [rows, shippingRow, estimateRow]);

    useEffect(() => {
        if (estimateRow?.vatStatus == 'Excluding VAT' && estimateRow?.vatPrice > 0) {
            let tempvat = (modalPrice * (estimateRow?.vatPrice / 100)).toFixed(2);
        }
    }, [subTotal, modalPrice, estimateRow]);



    const handleReloadCreditNote = () => {
        invalidateEstQuery();
    };

    const isMobile = useIsMobile();


    return (
        <div className="row m-0 w-100 est-nv-container">
            <div className="col-12 col-md-8 offset-md-2 p-0 p-md-2 inv-preview">
                <div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
                    <div className="client-header-bubble" />
                    <div className="d-flex flex-column gap-2 mb-4" style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
                        <div
                            style={{
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: 8,
                                minHeight: 38 // ensures enough height for the button
                            }}
                        >
                            {' '}
                            <button
                                type="button"
                                aria-label="Back"
                                onClick={() => history(-1)}
                                className="circle-back-btn"
                                style={{
                                    position: 'absolute',
                                    left: 20,
                                    top: '50%',
                                    transform: 'translateY(-50%)'
                                }}
                            >
                                {/* Replace with your fi arrow icon, example below */}
                                <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
                                    <path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                                <h5 style={{ textAlign: 'center', flex: 1, margin: 0, whiteSpace: 'nowrap' }}>Quotation {selectedEstimate?.estimation_number}</h5>
                                <StatusBadge itemStatus={selectedEstimate?.master_status?.name} />
                            </div>
                        </div>

                    
                    </div>
                </div>
                <div className="section-head-new pl-0 mb-1 mt-2 hide-on-mobile">
                </div>
                <div className="row hide-on-mobile">
                    <div className="col-12">
                        {!selectedEstimate ? (
                            <div style={{ marginTop: '-7px', marginBottom: '10.2px' }}>
                                <Skeleton variant="rounded" width={'100%'} height={160} style={{ borderRadius: '12px' }} />
                            </div>
                        ) : (
                            selectedEstimate?.is_credit_note !== 1 && (
                                salesType === 'invoice' && selectedEstimate?.master_status?.name !== 'Draft' && (
                                    <div>
                                        <ClientTimeline
                                            id={selectedEstimate?.id}
                                            source={'invoice'}
                                        />
                                    </div>
                                )
                            )
                        )}
                    </div>
                </div>
                <div className="row m-0 mobile-scroll-container">
                    <div className="show-on-mobile" style={{ width: '100%', display: 'flex' }}>
                        {!selectedEstimate ? (
                            <div style={{ width: '100%', marginBottom: '8px' }}>
                                <Skeleton variant="rounded" width={'100%'} height={34} style={{ borderRadius: '12px' }}></Skeleton>
                            </div>
                        ) : (
                            selectedEstimate?.is_credit_note !== 1 && (
                                salesType === 'invoice' && selectedEstimate?.master_status?.name !== 'Draft' && (
                                    <div style={{ width: '100%', marginBottom: '8px', paddingTop: 10 }}>
                                        
                                        <ClientTimeline
                                            id={selectedEstimate?.id}
                                            source={'invoice'}
                                        />
                                    </div>
                                )
                            )
                        )}
                    </div>
                    <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                        <QuotationPreview estimate={selectedEstimate} />
                        {!isMobile && (
                            <>
                                {selectedEstimate?.invoice?.id && <InvoiceComponent details={selectedEstimate} viewedBy="CLIENT" />}
                                {selectedEstimate?.qoutation?.id && <QoutationComponent details={selectedEstimate} viewedBy="CLIENT" />}
                                {selectedEstimate?.sales_order?.id && <SalesOrderComponent details={selectedEstimate} viewedBy="CLIENT" />}
                                
                                {selectedEstimate?.is_credit_note === 1 && selectedEstimate?.credit_payments?.length > 0 && (
                                    <CreditPaymentComponent details={selectedEstimate} onHandleReloadCreditNote={handleReloadCreditNote} />
                                )}
                                {selectedEstimate?.payments?.length > 0 && (
                                    <div style={{ padding: '0px 20px 20px 16px' }}>
                                        <div className="row mb10">
                                            <div className="col-12">
                                                <h2 className="d-flex font600" style={{ fontSize: '18px' }}>
                                                    Payments
                                                </h2>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-3 font600">Date</div>
                                            <div className="col-md-3 font600">Type</div>
                                            <div className="col-md-3 font600">Amount</div>
                                            <div className="col-md-3 font600">Processed By</div>
                                        </div>
                                        <hr className="mt8 mb8" />
                                        {selectedEstimate?.payments?.map((payment, index) => (
                                            <>
                                                <div className="row hover-row">
                                                    <div className="col-md-3">{moment(payment?.payment_date).format(CommonDateOnlyFormat)}</div>
                                                    <div className="col-md-3">
                                                        {payment?.pay_type == 'credit-note' ? (
                                                            payment?.credit_note?.credit_note_number ? (
                                                                <div
                                                                    className={`${
                                                                        hasEveryPermission(['View Estimation Details (Page)']) ? 'text-primary cursor-pointer' : ''
                                                                    }`}
                                                                    onClick={() => {
                                                                        if (hasEveryPermission(['View Estimation Details (Page)'])) {
                                                                            handleOpenNewTab('invoices', payment?.credit_note?.id);
                                                                        }
                                                                    }}
                                                                >
                                                                    Credit Note {payment?.credit_note?.credit_note_number}
                                                                </div>
                                                            ) : (
                                                                'Credit Note'
                                                            )
                                                        ) : payment?.pay_type == 'bank-charges' ? (
                                                            'Bank Charges'
                                                        ) : payment?.pay_type == 'credit_card' ? (
                                                            'Credit Card'
                                                        ) : payment?.pay_type == 'bank_cheque' ? (
                                                            'Bank Cheque'
                                                        ) : payment?.pay_type == 'cash' ? (
                                                            'Cash'
                                                        ) : payment?.pay_type == 'usdt' ? (
                                                            'USDT'
                                                        ) : (
                                                            'Wired'
                                                        )}
                                                    </div>
                                                    <div className="col-md-3  text-success">
                                                        {payment?.payment_amount && payment?.payment_currency ? (
                                                            <>
                                                                {getCurrencySymbol(payment?.payment_currency)}
                                                                {
                                                                    selectedEstimate?.is_credit_note === 1 ? (
                                                                        numberFormatter.format(Math.abs(payment?.payment_amount))
                                                                    ) : (
                                                                        numberFormatter.format(payment?.payment_amount)		
                                                                    )
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                {getCurrencySymbol(payment?.currency)}
                                                                {
                                                                    selectedEstimate?.is_credit_note === 1 ? (
                                                                        numberFormatter.format(Math.abs(payment?.amount_paid))
                                                                    ) : (
                                                                        numberFormatter.format(payment?.amount_paid)		
                                                                    )
                                                                }
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className="col-md-3">{payment?.user_created?.first_name}</div>
                                                    <div className="hover-button-container-lg mr-20 mt0">
                                                        <div>
                                                            <div className="hover-button">
                                                                {payment?.attachment && (
                                                                    <div
                                                                        className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
                                                                        style={{ marginLeft: '8px' }}
                                                                        onClick={() => {
                                                                            window.open(payment.attachment, '_blank');
                                                                        }}
                                                                    >
                                                                        <div style={{ margin: 'auto 5px auto 3px' }}>
                                                                            <FaPaperclip />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="mt8 mb8" />
                                            </>
                                        ))}
                                    </div>
                                )}
                                {selectedEstimate?.purchase_order?.length > 0 && <PurchaseOrderComponent details={selectedEstimate?.purchase_order} />}
                                {selectedEstimate?.shipments?.length > 0 && <ShipmentsComponent details={selectedEstimate} />}
                             
                            </>
                        )}
                    </div>
                    {isMobile && (
                        <>
                            {/* Each block is now wrapped in its own card for mobile */}
                            {salesType === 'estimate' && selectedEstimate?.invoice?.id && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <InvoiceComponent details={selectedEstimate}  viewedBy="CLIENT" />
                                </div>
                            )}
                            {salesType === 'invoice' && selectedEstimate?.qoutation?.id && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <QoutationComponent details={selectedEstimate} viewedBy="CLIENT" />
                                </div>
                            )}
                            {selectedEstimate?.sales_order?.id && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <SalesOrderComponent details={selectedEstimate} viewedBy="CLIENT" />
                                </div>
                            )}
                            {selectedEstimate?.is_credit_note === 1 && selectedEstimate?.credit_payments?.length > 0 && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <CreditPaymentComponent details={selectedEstimate} onHandleReloadCreditNote={handleReloadCreditNote} />
                                </div>
                            )}
                            {selectedEstimate?.payments?.length > 0 && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <h2
                                        className="font600"
                                        style={{
                                            fontSize: '18px',
                                            borderBottom: '1px solid #e0e0e0',
                                            paddingBottom: '10px',
                                            marginBottom: 0
                                        }}
                                    >
                                        Payments
                                    </h2>
                                    {selectedEstimate?.payments?.map((payment, index) => (
                                        <div
                                            key={payment?.id || index}
                                            style={{
                                                display: 'flex',
                                                width: '100%',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                borderBottom: '1px solid #eee',
                                                paddingTop: 5,
                                                paddingBottom: 5
                                            }}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div style={{ fontWeight: 500 }}>
                                                    {payment?.pay_type == 'credit-note'
                                                        ? 'Credit Note'
                                                        : payment?.pay_type == 'bank-charges'
                                                        ? 'Bank Charges'
                                                        : payment?.pay_type == 'credit_card'
                                                        ? 'Credit Card'
                                                        : payment?.pay_type == 'bank_cheque'
                                                        ? 'Bank Cheque'
                                                        : payment?.pay_type == 'cash'
                                                        ? 'Cash'
                                                        : 'Wired'}
                                                </div>
                                                <div style={{ fontWeight: 400 }}>{moment(payment?.payment_date).format(CommonDateOnlyFormat)}</div>
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                                <div style={{ fontWeight: 500 }}>
                                                    {getCurrencySymbol(payment?.currency)} {numberFormatter.format(payment?.amount_paid)}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {selectedEstimate?.purchase_order?.length > 0 && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <PurchaseOrderComponent details={selectedEstimate?.purchase_order} />
                                </div>
                            )}
                            {selectedEstimate?.shipments?.length > 0 && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <ShipmentsComponent details={selectedEstimate} />
                                </div>
                            )}
                        </>
                    )}
                    
                    {(selectedEstimate?.master_status?.name !== 'Draft' && salesType !== 'estimate') && (
                        <div className="mb-3 w-100">
                            {
                                !selectedEstimate ? (
                                    <div>
                                        <Skeleton variant="rounded" width={'100%'} height={75} style={{ borderRadius: '12px' }} />
                                    </div>
                                ) : (
                                    selectedEstimate?.attachments?.length > 0 && (
                                        selectedEstimate?.attachments?.map((attachment, index) => (
                                            <div className="row m-0" key={index}>
                                                <div className="col-12" style={{ padding: '0' }}>
                                                    <div className="card shadow-sm bg-white mb-4 w-100 border card-border-gray">
                                                        <div className="card-header-radius-0" style={{ padding: '0px 10px' }}>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="section-head row" style={{ padding: '0px 10px !important', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                                                                        <div style={{ marginTop: '-4px', alignItems: 'center', fontSize: '14px', padding: '8px 0' }} className="col-md-12">
                                                                            {attachment?.filename}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="card-body text-center" style={{ padding: '0px' }}>
                                                            {attachment?.extension == 'pdf' ? (
                                                                <PdfViewer src={attachment?.attachment_url + '#toolbar=0&navpanes=0&zoom=FitW'} />
                                                            ) : (
                                                                // <PdfViewer src={'https://mixglobalapi.projectmix.ai/storage/uploads/purchase_invoices/2/Purchase-Invoice-PO25002-1746620742.pdf#toolbar=0&navpanes=0&zoom=FitW'} />
                                                                // <PdfViewer src={'https://mgappapi.projectmix.ai/storage/uploads/purchase_invoices/161/Purchase-Invoice-PO24160-1735895437.pdf#toolbar=0&navpanes=0&zoom=FitW'} />
                                                                <img src={attachment?.attachment_url} className="img-fluid" />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )	
                                )
                            }
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default QuotationDetails;
